// Мягкое лето, мягкий и холодный колорит + переделал
import { Palette } from '@/types/palette.type';

export const softSummerPalette = [
  '#DEDCCD',
  '#DDD4C3',
  '#C5C5B9',
  '#9B8E88',
  '#72655F',
  '#C3BCB4',
  '#ADA694',
  '#8D8175',
  '#8F746B',
  '#503D3F',
  '#B0B0AE',
  '#686C6D',
  '#7C7B76',
  '#5D5553',
  '#413F40',
  '#F3B8BE',
  '#E4A09D',
  '#C88A8D',
  '#B48285',
  '#713743',
  '#FA9DA8',
  '#F87B89',
  '#E4566E',
  '#C3445F',
  '#983645',
  '#FAA0BC',
  '#E87F96',
  '#D85076',
  '#A03851',
  '#60303C',
  '#E5A1B8',
  '#CD899E',
  '#AF6F7F',
  '#88495E',
  '#503345',

  '#E3D99E',
  '#D4CC84',
  '#89C099',
  '#5E927C',
  '#36564B',
  '#7EBCAD',
  '#5AA088',
  '#417060',
  '#438279',
  '#2E514B',
  '#78BAC6',
  '#57969F',
  '#48757A',
  '#598D89',
  '#285155',
  '#90C0CC',
  '#71AAB5',
  '#477F8E',
  '#527A93',
  '#2E4452',
  '#A4AEC7',
  '#8892B5',
  '#777BA1',
  '#5A5E7B',
  '#35364A',
  '#9E9BAE',
  '#7F7C8F',
  '#55485A',
];
//Тёмная осень — тёплый и тёмный колорит + переделал
export const darkAutumnPalette = [
  '#E5D6C1',
  '#CEBAA2',
  '#E9D1AF',
  '#EDCBA6',
  '#CDAA82',
  '#E0D7AE',
  '#D3D5A4',
  '#EED8A6',
  '#F8C2B6',
  '#9BD2CD',
  '#C4BDB5',
  '#8C857D',
  '#58504D',
  '#A59482',
  '#5D4D4E',
  '#392933',
  '#1B3430',
  '#263356',
  '#213454',
  '#252525',
  '#F4C581',
  '#D5AC6A',
  '#B88C5B',
  '#EBA77A',
  '#C17960',
  '#F6858B',
  '#D34D58',
  '#E87F6A',
  '#BF6658',
  '#713535',
  '#F3948E',
  '#F07B74',
  '#C65454',
  '#9A3D47',
  '#6E272F',

  '#D36C65',
  '#D83D4D',
  '#BC344A',
  '#9E2A41',
  '#4A2127',
  '#A6BB82',
  '#ADBF69',
  '#8D9C59',
  '#5F6738',
  '#2B3127',
  '#4EC5BF',
  '#2D9F97',
  '#3E9283',
  '#296452',
  '#1C3B36',
  '#5FB8CA',
  '#2798B6',
  '#1D738A',
  '#156773',
  '#1C403E',
  '#D9A7C0',
  '#C1759B',
  '#9D4F76',
  '#6F3450',
  '#224058',
  '#998755',
  '#827146',
  '#4C442F',
];
//Холодное лето — холодный и мягкий колорит + переделал
export const coldSummerPalette = [
  '#DCDACD',
  '#D0CCC3',
  '#BEBBB2',
  '#908B85',
  '#605752',
  '#E8E0A1',
  '#E1D799',
  '#9FA696',
  '#7C8276',
  '#5B5851',
  '#C5C4C2',
  '#B9AFAE',
  '#8A7E80',
  '#6F6065',
  '#4A4448',
  '#CEC4C3',
  '#B1A49E',
  '#987B7F',
  '#634E53',
  '#413539',
  '#A2B1B6',
  '#7A8B9B',
  '#95A6AD',
  '#6D747A',
  '#3F464C',
  '#9BBABC',
  '#708C8D',
  '#4E8693',
  '#2C6E7A',
  '#21515D',
  '#F17889',
  '#DF4F66',
  '#DE7089',
  '#AC3E5B',
  '#722D3F',

  '#FDC4D7',
  '#EB9FBD',
  '#D58AA8',
  '#B45E85',
  '#852F54',
  '#63C6A9',
  '#379273',
  '#1F7960',
  '#1B897E',
  '#135855',
  '#53CEBC',
  '#2A947E',
  '#1A8662',
  '#146749',
  '#174731',
  '#5CC1DD',
  '#2A87A6',
  '#3DB8BD',
  '#238F99',
  '#195B67',
  '#8AC0E4',
  '#62ABCB',
  '#508EB5',
  '#346EA0',
  '#23456B',
  '#9EA7D2',
  '#7C7FB2',
  '#4B4978',
  '#504776',
];

//Светлая весна — светлый и тёплый колорит переделал
export const lightSpringPalette = [
  '#ECDCC3',
  '#E1D4C4',
  '#EDD8B9',
  '#E4D1A7',
  '#D6BC97',
  '#EEC7B6',
  '#F3B39A',
  '#CFC9A7',
  '#A2A588',
  '#6A6D66',
  '#CAC4B6',
  '#B5B1A5',
  '#7E7B72',
  '#67625C',
  '#69574B',
  '#B4B6B3',
  '#7C7C7A',
  '#626866',
  '#857456',
  '#805F50',
  '#F4DF76',
  '#F8D47C',
  '#F1C969',
  '#FCD08F',
  '#F6C36A',
  '#F1BB97',
  '#F89D6E',
  '#F69680',
  '#F26B65',
  '#E65856',
  '#F1A0A9',
  '#F59D9C',
  '#F48282',
  '#F0646F',
  '#E74F64',

  '#F9B5C2',
  '#F17E9F',
  '#F15B80',
  '#F2778C',
  '#DF3F59',
  '#BBDA97',
  '#98CD89',
  '#79C270',
  '#52B855',
  '#16A36E',
  '#7ECDCA',
  '#4EC1BC',
  '#73C7B0',
  '#30BAA0',
  '#348878',
  '#90C7E5',
  '#70B3DD',
  '#70C7DB',
  '#2FB1C7',
  '#278B9A',
  '#86AFDD',
  '#6987C5',
  '#3860A8',
  '#276B9A',
  '#315086',
  '#B0A7D2',
  '#9782BD',
  '#604D85',
];

//Мягкая осень — мягкий и тёплый колорит + переделал
export const softAutumnPalette = [
  '#DBDCD4',
  '#DFDECC',
  '#DDD7C7',
  '#C3C1AA',
  '#B7B096',
  '#C2C2B8',
  '#9D968C',
  '#66635C',
  '#848A88',
  '#3B4345',
  '#A7A781',
  '#7E7D5E',
  '#535041',
  '#84926E',
  '#3D4635',
  '#D7AA81',
  '#C59776',
  '#98795D',
  '#6E5843',
  '#433431',
  '#906253',
  '#895351',
  '#673735',
  '#553634',
  '#4E2F34',
  '#E5CF93',
  '#F1C995',
  '#EECB89',
  '#DDB779',
  '#C5A870',
  '#EF9795',
  '#E7797A',
  '#B64F58',
  '#E67571',
  '#A4484B',

  '#FAC7C3',
  '#FFA99C',
  '#EE7D7F',
  '#C45657',
  '#8E2F35',
  '#FDC0C7',
  '#FEA6B2',
  '#EB7084',
  '#C14A5E',
  '#862A39',
  '#96D5BA',
  '#77BE9E',
  '#46846B',
  '#348A7D',
  '#1A423A',
  '#57C2B8',
  '#36A698',
  '#14635E',
  '#277357',
  '#1C3F29',
  '#67AAC7',
  '#367BA5',
  '#174C6E',
  '#5474A5',
  '#203256',
  '#8792C0',
  '#55608D',
  '#2E3351',
];
// Холодная зима — холодный и яркий колорит переделал
export const coldWinterPalette = [
  '#FFFFFF',
  '#E2DFD8',
  '#D1D1C7',
  '#9C938C',
  '#776F6C',
  '#CED2D3',
  '#B8C1C0',
  '#8A9493',
  '#3B4345',
  '#0E0E0E',
  '#F5D4DF',
  '#FBF097',
  '#B0E8C5',
  '#A7E8EC',
  '#C9D4F0',
  '#FAEB74',
  '#FDE55F',
  '#FFD95C',
  '#DC364C',
  '#AD2742',
  '#33C475',
  '#15B764',
  '#107C42',
  '#125C3B',
  '#1C372E',
  '#18BE8E',
  '#127B5D',
  '#124A3F',
  '#24ADB7',
  '#136772',
  '#41B8D6',
  '#2299C3',
  '#0E6085',
  '#2D84C7',
  '#0D60AE',

  '#FEC2E8',
  '#FE98DA',
  '#FA77B9',
  '#F863B4',
  '#AA2A67',
  '#FE93C1',
  '#F45E8C',
  '#F65D9E',
  '#A63168',
  '#542339',
  '#F59DCF',
  '#DC5892',
  '#A63168',
  '#752444',
  '#3A2230',
  '#C981CD',
  '#89509F',
  '#5E3579',
  '#A058A2',
  '#442A59',
  '#7B3569',
  '#5A3771',
  '#383979',
  '#2F2C59',
  '#1E2F4D',
  '#3B66B4',
  '#20418E',
  '#222E54',
  '#292021',
];
//Тёплая осень — тёплый и мягкий колорит переделал
export const warmAutumnPalette = [
  '#ECE0CA',
  '#E5D7BD',
  '#D5CAB4',
  '#EDDFB8',
  '#F2D6A4',
  '#F4D5C3',
  '#F6C6B0',
  '#C2C4B6',
  '#948F8B',
  '#64504F',
  '#C5C9AE',
  '#90957F',
  '#958472',
  '#716A5A',
  '#544E42',
  '#D1B590',
  '#B89C77',
  '#837061',
  '#57473A',
  '#4A3B3E',
  '#EDBC93',
  '#B39C7A',
  '#AE6F5D',
  '#8A4D4C',
  '#502D31',
  '#F6CA71',
  '#F6BA71',
  '#DCAA65',
  '#BC8B51',
  '#765836',
  '#F3A66E',
  '#E08654',
  '#DF7C53',
  '#C05241',
  '#8A3636',

  '#FEA98A',
  '#FA807D',
  '#F97F7A',
  '#ED6057',
  '#D73741',
  '#EE978E',
  '#E97081',
  '#AB3E51',
  '#7E2D36',
  '#44232A',
  '#C6C38E',
  '#A2AD75',
  '#ADA14B',
  '#776A35',
  '#423C24',
  '#8CB976',
  '#477A37',
  '#2D8052',
  '#216041',
  '#1D3E29',
  '#3FB9BE',
  '#25848A',
  '#51BBCB',
  '#1D7C8E',
  '#16515F',
  '#6788B5',
  '#384B76',
  '#7A6892',
  '#4F425C',
];
//Светлое лето — светлый и холодный колорит переделал
export const lightSummerPalette = [
  '#DCDACD',
  '#D7D2BF',
  '#BFBDB1',
  '#A59D92',
  '#827D77',
  '#AFB5B5',
  '#8A9493',
  '#6E7474',
  '#7D949C',
  '#4F6976',
  '#C3BFB6',
  '#90777A',
  '#685656',
  '#5C4C4D',
  '#553743',
  '#F1DAB0',
  '#ECD2A1',
  '#F0DA8E',
  '#FCDD8D',
  '#F9D081',
  '#F7888E',
  '#ED5965',
  '#F66C7B',
  '#E03C55',
  '#BB324E',
  '#F9959F',
  '#F7788D',
  '#F15C79',
  '#E94C69',
  '#CD2D53',
  '#F2AAB5',
  '#F398B7',
  '#F982A8',
  '#DD5885',
  '#AF476C',

  '#78DCB8',
  '#1DC796',
  '#1EA384',
  '#199E73',
  '#1F674F',
  '#63DBBF',
  '#1BC8AA',
  '#33CFC4',
  '#23B7AB',
  '#207D75',
  '#6FCFDF',
  '#38B5C7',
  '#25C3C2',
  '#299FA9',
  '#258093',
  '#83C9EA',
  '#6BB8E6',
  '#4292CF',
  '#1E68A5',
  '#155B8E',
  '#8FABDD',
  '#7A98D4',
  '#5177BE',
  '#36629F',
  '#1E457E',
  '#9782C7',
  '#6E5A9F',
  '#524783',
];

//Тёмная зима — тёмный и холодный колорит переделал
export const darkWinterPalette = [
  '#FFFFFF',
  '#E3E0D7',
  '#CACBC3',
  '#A6A39E',
  '#78736D',
  '#D4D8D9',
  '#C9CFCF',
  '#A3A7A6',
  '#434D4F',
  '#000000',
  '#EEE8AE',
  '#EED4D7',
  '#BEE4D9',
  '#B3DAE9',
  '#C5CCE8',
  '#F9E680',
  '#FAD57C',
  '#F0C777',
  '#90C55D',
  '#4C7032',
  '#D33953',
  '#E65671',
  '#F985AA',
  '#E2537E',
  '#83253F',
  '#BA2542',
  '#97253F',
  '#A52B38',
  '#7D2436',
  '#622534',
  '#F07786',
  '#DF4D64',
  '#892935',
  '#6C272C',
  '#382322',

  '#23B783',
  '#146449',
  '#1A4239',
  '#30362A',
  '#362724',
  '#3ACAB3',
  '#147063',
  '#28A0B1',
  '#147585',
  '#194143',
  '#60C1E1',
  '#1686AC',
  '#155674',
  '#1C73A0',
  '#1C394B',
  '#70BBE3',
  '#1C71A8',
  '#609EF1',
  '#215B9A',
  '#1C3353',
  '#B897C6',
  '#A373A7',
  '#59335A',
  '#2D2439',
  '#312026',
  '#E788A8',
  '#973D59',
  '#3D222B',
];
//Тёплая весна — тёплый и яркий колорит переделал
export const warmSpringPalette = [
  '#F5E0C5',
  '#ECD1BC',
  '#FAD6A6',
  '#E7BE7C',
  '#DEAD82',
  '#C2C4B9',
  '#AEAD9B',
  '#989687',
  '#7F7B6F',
  '#584E44',
  '#D6CC8F',
  '#C8AC84',
  '#B79363',
  '#735539',
  '#463229',
  '#F5BB96',
  '#DC976E',
  '#8C4835',
  '#794537',
  '#5B322C',
  '#F0C98E',
  '#F1D582',
  '#F4CD72',
  '#F0BB51',
  '#F0AF53',
  '#F1A38D',
  '#F37656',
  '#F98077',
  '#EF5861',
  '#DE3844',
  '#EE7675',
  '#E34D4E',
  '#D93649',
  '#F1616B',
  '#D9374F',
  '#C8DA74',
  '#AFC547',
  '#8C9D35',
  '#33A948',
  '#227235',
  '#74DA74',
  '#59CA56',
  '#209836',
  '#117E45',
  '#0F7752',
  '#5AD271',
  '#40C971',
  '#48CEA9',
  '#16A47C',
  '#10795B',
  '#57D0AF',
  '#2FBA9D',
  '#20C5B4',
  '#20A799',
  '#1B908A',
  '#A1B9E7',
  '#7399D8',
  '#587DCB',
  '#0063A7',
  '#124270',
  '#C993D1',
  '#996ABA',
  '#683E88',
  '#463B87',
];
// Яркая весна — яркий и тёплый колорит переделал
export const brightSpringPalette = [
  '#E4E2D3',
  '#E1DAC8',
  '#E6D8BB',
  '#D5CAB8',
  '#C0C4B3',
  '#ABAFAE',
  '#969F9A',
  '#595F5D',
  '#394241',
  '#202020',
  '#BAB6AD',
  '#685E55',
  '#322C2C',
  '#0F5591',
  '#17416B',
  '#E6DFA9',
  '#FBCBBF',
  '#A2E4D8',
  '#A5E3EE',
  '#BAC1EB',
  '#FBD05F',
  '#FBC56B',
  '#ECAB45',
  '#DB9454',
  '#B13C32',
  '#F9AAAD',
  '#FD8C84',
  '#EE5558',
  '#FD7B61',
  '#E54449',
  '#F5A2BC',
  '#F784A5',
  '#DD476A',
  '#FD7C90',
  '#D93F5B',
  '#FF9ACA',
  '#FC7FB9',
  '#EC488F',
  '#F9659F',
  '#C73063',
  '#C1DA74',
  '#8FBB4A',
  '#4F9636',
  '#2F7030',
  '#264B2C',
  '#27C76F',
  '#148F4E',
  '#116939',
  '#15A769',
  '#125B3E',
  '#4BD5D7',
  '#21B7B6',
  '#1A857D',
  '#28ADBC',
  '#14626C',
  '#449FD8',
  '#1070BC',
  '#9E79C9',
  '#7151A4',
  '#382F72',
  '#EE89C1',
  '#DB5296',
  '#88275A',
];
//Яркая зима яркий и холодный колорит
export const brightWinterPalette = [
  '#FFFFFF',
  '#E4E2D6',
  '#DDD7C7',
  '#9E9D99',
  '#605D56',
  '#CFD1D0',
  '#B9BFBD',
  '#97A09B',
  '#3C4242',
  '#141414',
  '#EFE5AA',
  '#F7D1D0',
  '#B2E5DE',
  '#FBD3ED',
  '#D7D1ED',
  '#F3DD78',
  '#FED96E',
  '#FCCD65',
  '#ABD454',
  '#81A54E',
  '#F47C86',
  '#E54D5C',
  '#D3363F',
  '#D9406C',
  '#9A2947',
  '#F378A6',
  '#DC4A71',
  '#E64F70',
  '#CC2B4A',
  '#842336',
  '#F078BF',
  '#C54894',
  '#812B6A',
  '#BF3277',
  '#662247',
  '#E078C7',
  '#9B4292',
  '#632D6B',
  '#604E9A',
  '#2F2F6D',
  '#41D287',
  '#1AA856',
  '#13643B',
  '#1FA793',
  '#16534C',
  '#50D4E0',
  '#259FA2',
  '#4CC7E9',
  '#24A1CD',
  '#135F7F',
  '#71B5E2',
  '#264F9F',
  '#5C94CD',
  '#2058A5',
  '#1B305F',
  '#587EC7',
  '#264F9F',
  '#1E2C53',
  '#2C2022',
  '#241E20',
  '#857DC6',
  '#6059A7',
  '#232959',
];

export const defaultPaletteCards: { id: number; color: string }[] = [
  { id: 1, color: '#fff' },
  { id: 2, color: '#fff' },
  { id: 3, color: '#fff' },
  { id: 4, color: '#fff' },
  { id: 5, color: '#fff' },
];

export const softSummerPaletteShort: string[] = [
  '#B28184',
  '#807D92',
  '#54475B',
  '#E5D99F',
  '#527A93',
  '#CE88A0',
  '#C34461',
  '#487379',
  '#37564E',
  '#E2A1B7',
  '#A4AFC5',
  '#5E5D7C',
];

export const softAutumnPaletteShort: string[] = [
  '#6E5841',
  '#A7A781',
  '#F1C795',
  '#A4474F',
  '#FFA99A',
  '#43836B',
  '#534F43',
  '#C6977B',
  '#5474A5',
  '#164C6E',
  '#C5A771',
  '#8B2E36',
];

export const brightWinterPaletteShort: string[] = [
  '#D3363F',
  '#FFFFFF',
  '#F3DD78',
  '#ABD452',
  '#1AA856',
  '#41D287',
  '#4CC7E9',
  '#264F9F',
  '#604E9A',
  '#D974C0',
  '#FBD3ED',
  '#141414',
];

export const brightSpringPaletteShort: string[] = [
  '#FBD05F',
  '#FD7B61',
  '#E54449',
  '#8FBB4A',
  '#2F7030',
  '#F784A5',
  '#EC488F',
  '#88275A',
  '#A2E4D8',
  '#28ADBC',
  '#1070BC',
  '#7151A4',
];

export const warmSpringPaletteShort: string[] = [
  '#FAD6A6',
  '#F0BB51',
  '#AFC546',
  '#8C9D35',
  '#735539',
  '#F98077',
  '#EF5861',
  '#8C4835',
  '#48CEA9',
  '#33A948',
  '#C993D1',
  '#587DCB',
];

export const lightSpringPaletteShort: string[] = [
  '#4EC1BC',
  '#F1BB97',
  '#F8D47C',
  '#F99E71',
  '#F48282',
  '#F26B65',
  '#BADA97',
  '#79C270',
  '#F47E9E',
  '#EABCC6',
  '#85AFDD',
  '#B0A7D2',
];

export const lightSummerPaletteShort: string[] = [
  '#F398B7',
  '#6FCFDF',
  '#4292CF',
  '#A59D92',
  '#F1DAB0',
  '#DD5885',
  '#63DBBF',
  '#1DC796',
  '#7D949C',
  '#8DAADC',
  '#9782C7',
  '#F2AAB5',
];

export const coldSummerPaletteShort: string[] = [
  '#6F6065',
  '#2E6E7A',
  '#E8E0A1',
  '#DE7089',
  '#DF4F66',
  '#852F54',
  '#346EA0',
  '#4B4978',
  '#5CC1DD',
  '#FDC4D7',
  '#B35D85',
  '#1F7960',
];

export const warmAutumnPaletteShort: string[] = [
  '#F6BA72',
  '#E18552',
  '#BE5242',
  '#D6353B',
  '#ADA14B',
  '#715638',
  '#477A37',
  '#1D7C8E',
  '#6788B5',
  '#4F425C',
  '#423C24',
  '#883837',
];

export const darkAutumnPaletteShort: string[] = [
  '#C65454',
  '#6E272F',
  '#4A2127',
  '#8D9C59',
  '#1B3430',
  '#392933',
  '#6F3450',
  '#E87F6A',
  '#263356',
  '#F4C581',
  '#B88C5B',
  '#4C432E',
];

export const darkWinterPaletteShort: string[] = [
  '#000000',
  '#622535',
  '#E1527E',
  '#203353',
  '#1F5B99',
  '#127685',
  '#4D6F32',
  '#1E413B',
  '#973D59',
  '#59335A',
  '#3D212D',
  '#A52A3C',
];

export const coldWinterPaletteShort: string[] = [
  '#F863B4',
  '#0E0E0E',
  '#2299C3',
  '#20418E',
  '#FBF097',
  '#C9D4F0',
  '#FE98DA',
  '#AA2A67',
  '#33C574',
  '#F65D8C',
  '#7B3569',
  '#89509F',
];

export const palettesObjShort: Record<Palette, string[]> = {
  softSummerPalette: softSummerPaletteShort,
  softAutumnPalette: softAutumnPaletteShort,
  brightWinterPalette: brightWinterPaletteShort,
  brightSpringPalette: brightSpringPaletteShort,
  warmSpringPalette: warmSpringPaletteShort,
  lightSpringPalette: lightSpringPaletteShort,
  lightSummerPalette: lightSummerPaletteShort,
  coldWinterPalette: coldWinterPaletteShort,
  coldSummerPalette: coldSummerPaletteShort,
  warmAutumnPalette: warmAutumnPaletteShort,
  darkAutumnPalette: darkAutumnPaletteShort,
  darkWinterPalette: darkWinterPaletteShort,
};

export const palettesObj: Record<Palette, string[]> = {
  softSummerPalette: softSummerPalette,
  darkAutumnPalette: darkAutumnPalette,
  coldSummerPalette: coldSummerPalette,
  lightSpringPalette: lightSpringPalette,
  softAutumnPalette: softAutumnPalette,
  brightSpringPalette: brightSpringPalette,
  warmSpringPalette: warmSpringPalette,
  darkWinterPalette: darkWinterPalette,
  lightSummerPalette: lightSummerPalette,
  warmAutumnPalette: warmAutumnPalette,
  coldWinterPalette: coldWinterPalette,
  brightWinterPalette: brightWinterPalette,
};
